module.exports = __webpack_public_path__ + "assets/img/quickStart-bg-book.ed92f754.png";